export default "__VITE_ASSET__D4ljJ2Yx__"